import { Dictionary } from 'lodash';

export function toInitData<T extends Dictionary<any>>(object: T) {
  return Object.entries(object)
    .map(([key, value]) => `${key}=${value}`)
    .sort()
    .join('&');
}
